import { render, staticRenderFns } from "./CdButton.vue?vue&type=template&id=56c424c6&"
import script from "./CdButton.vue?vue&type=script&lang=js&"
export * from "./CdButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c424c6')) {
      api.createRecord('56c424c6', component.options)
    } else {
      api.reload('56c424c6', component.options)
    }
    module.hot.accept("./CdButton.vue?vue&type=template&id=56c424c6&", function () {
      api.rerender('56c424c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atomicUIComponents/button/CdButton.vue"
export default component.exports